export enum Columns {
  SkuChart = 'sku_chart',
  Size = 'size',
  SkuName = 'sku_name',
  SkuExternalId = 'sku_external_id',
  Replenishment = 'replenishment',
  Sold = 'sold',
  SalesRate = 'salesRate',
  Stock = 'stock',
  OptimalStock = 'optimalStock',
  WarehouseInventory = 'warehouseInventory',
  WhNames = 'warehouseName',
  NextReplenishment = 'replenishmentTime',
  Coverage = 'coverage',
  ExpectedCoverage = 'expectedCoverage',
  Constraints = 'constraints',
  MasterSkuName = 'master_sku_name',
  MasterSkuExternalId = 'master_sku_external_id',
}
